<div>range1: {{ range1 | json }}</div>
<div>range2: {{ range2 | json }}</div>
<div>range3: {{ range3 | json }}</div>

<div>overlap 1 and 2?: {{ isOverlap1and2 }}</div>
<div>overlap 2 and 3?: {{ isOverlap2and3 }}</div>
